module.exports = __webpack_public_path__ + "static/media/flask-logo.d91971f7.svg";